import { hasValue } from './hasValue';
import realisticCountryData from './realistic_country_data.json';

export function enhanceData({
  countryIso,
  currencyIso,
  example
}: {
  countryIso: string | undefined;
  currencyIso: string | undefined;
  example: any;
}) {
  if (!hasValue(countryIso) || !hasValue(currencyIso)) {
    return example;
  }

  const match = realisticCountryData.find((x) => x.isoCode === countryIso);

  return {
    ...example,
    currency_code: currencyIso,
    currency_of_transfer: currencyIso,
    ...(example?.requested_execution_date && {
      requested_execution_date: getRandomDate(new Date())
    }),
    creditor: {
      ...example?.creditor,
      address_lines: match?.address,
      city: match?.capital,
      birthdate: getRandomDate(undefined, new Date('2000-01-01')),
      country_code: countryIso,
      country_of_birth_code: countryIso,
      state: match?.state,
      name: match?.personName,
      street_name: match?.address,
      mobile_number: match?.mobileNumber,
      postcode: match?.postcode,
      ...(example?.creditor?.id_expiry_date && {
        id_expiry_date: getRandomDate(new Date('2026-01-01'))
      }),
      ...(example?.creditor?.id_issuing_date && {
        id_issuing_date: getRandomDate(undefined, new Date())
      })
    },
    creditor_account: {
      ...example?.creditor_account,
      ...(example?.creditor_account?.iban && {
        iban: match?.iban
      }),
      ...(example?.creditor_account?.bank_name && {
        bank_name: example?.creditor_account?.bank_name ?? match?.bankName
      })
    },
    ultimate_debtor: {
      ...example?.ultimate_debtor,
      address_lines: match?.address,
      city: match?.capital,
      country_code: countryIso,
      birthdate: getRandomDate(undefined, new Date('2000-01-01')),
      country_of_birth_code: countryIso,
      country_of_residence_code: countryIso,
      state: match?.state,
      name: match?.personName,
      street_name: match?.address,
      mobile_number: match?.mobileNumber,
      postcode: match?.postcode,
      ...(example?.ultimate_debtor?.id_expiry_date && {
        id_expiry_date: getRandomDate(new Date('2026-01-01'))
      }),
      ...(example?.ultimate_debtor?.id_issuing_date && {
        id_issuing_date: getRandomDate(undefined, new Date())
      })
    }
  };
}

function getRandomDate(
  startDate: Date = new Date('1970-01-01'),
  endDate: Date = new Date('2028-12-31')
) {
  const randomDate = new Date(
    startDate.getTime() +
      Math.random() * (endDate.getTime() - startDate.getTime())
  );
  const year = randomDate.getFullYear();
  const month = String(randomDate.getMonth() + 1).padStart(2, '0');
  const day = String(randomDate.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
